/**
 * Class description
 *
 * Created: 2019-07-30
 * @author jonas
 */
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";

export interface BitmapTextStyleData {
    fontName: string;
    fontSize?: number;
    align?: string;
    tint?: number;
    letterSpacing?: number;
    maxWidth?: number;
}

export class HorribleHeroesTextStyles {
    public static FS_OUTRO_COUNT_UP: BitmapTextStyleData = {
        fontName: "NumbersWinCountUp",
        fontSize: 25,
        tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    public static FS_OUTRO: BitmapTextStyleData = {
        fontName: "NumbersWinCountUp",
        fontSize: 80,
        tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    public static FS_OUTRO_COUNT: BitmapTextStyleData = {
        fontName: "NumbersWinCountUp",
        fontSize: 45,
        tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    public static WAYS_FONT: BitmapTextStyleData = {
        fontName: "waysFont",
        fontSize: 24,
        tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    public static WIN_COUNT_UP: BitmapTextStyleData = {
        fontName: "NumbersWinCountUp",
        fontSize: 55,
        tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    public static HEROES_INTRO_QUOTE_FONT: PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily: "HeroesIntro",
        fontSize: 16, // need to update in HeroesIntroView.ts in adjustText method as well
        fontWeight: FontWeight.NORMAL,
        dropShadow: false,
        fill: "#000000",
        padding: 10,
        wordWrap: true,
        wordWrapWidth: 230,
        align: "center",
        lineHeight: 18
    });
}